import getChartColorsArray from "Common/ChartsDynamicColor";
import { useEffect, useState } from "react";

const useChartColors = (chartId: string) => {
  const [chartColors, setChartColors] = useState<string[]>([]);

  useEffect(() => {
    const colors: string[] | undefined = getChartColorsArray(chartId);
    if (colors) {
      setChartColors(colors);
    }
  }, [chartId]);

  return chartColors;
};

export default useChartColors;
